/**
 * Backend host only (no path), e.g. https://api.your-domain.example
 *
 * If REACT_APP_API_URL is not set, default to same-origin so production can run
 * behind a reverse proxy without hardcoded environment URLs.
 */
export const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin;

/**
 * API version prefix. Default /api/v1 (preferred). Set REACT_APP_API_PREFIX=/api for legacy only.
 */
export const API_PREFIX = (process.env.REACT_APP_API_PREFIX || '/api/v1').replace(/\/$/, '');

/** Host + prefix for raw fetch(): e.g. https://api.your-domain.example/api/v1 */
export const API_ROOT = `${API_BASE_URL}${API_PREFIX}`;

/**
 * Path segment for axios when baseURL is API_BASE_URL only, e.g. apiPath('/auth/login') -> /api/v1/auth/login
 */
export function apiPath(relativePath: string): string {
  const p = relativePath.startsWith('/') ? relativePath : `/${relativePath}`;
  return `${API_PREFIX}${p}`;
}
